import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
import store from '../store'
const apiModule = api.promocodes
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: 'desc',
      showOrder: true
    },
    createdAt: {
      data: 'createdAt',
      title: 'Дата создания',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    updatedAt: {
      data: 'updatedAt',
      title: 'Дата последнего обновления',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    bonus: {
      data: 'bonus',
      title: 'Бонус',
      value: 0,
      type: 'bonus',
      order: null,
      showOrder: true
    },
    group: {
      data: 'group',
      title: 'Группа',
      value: null,
      type: null,
      handler: function (data) {
        let group = data.group
        if (!group) return 'нет'
        return group.name
      }
    },
    groupId: {
      data: 'groupId',
      title: 'ID группы',
      value: null,
      type: null,
      handler: function (data) {
        if (!data.groupId) return 'нет'
        return data.groupId
      },
      order: null,
      showOrder: true
    },
    name: {
      data: 'name',
      title: 'Имя',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    sale: {
      data: 'sale',
      title: 'Скидка',
      value: 0,
      type: 'sale',
      order: null,
      showOrder: true
    },
    useCount: {
      data: 'useCount',
      title: 'Количество использований',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    dateEnd: {
      data: 'dateEnd',
      title: 'Дата завершения действия',
      value: null,
      type: 'date',
      order: null,
      showOrder: true
    }
  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  id: null,
  show: 'all',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {
    name: null,
    sale: null,
    bonus: null,
    useCount: null
  }
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getShow (state) { return state.show },
  getOne (state) { return state.question },
  getAll (state) { return state.questions },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.question = data },
  setAll (state, data) { state.questions = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  }
}
const actions = {
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    for (let err in errors) {
      commit('setErrors', { param: err, value: null })
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'one')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule[role()].getOne, { id: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async createOrUpdate ({ state, commit, dispatch }, data) {
    try {
      let dataNew = mapper.dataToRequest(data.data, data.required)
      if (!dataNew.name) commit('setErrors', { param: 'name', value: errorsStr.empty })
      if (!dataNew.bonus) dataNew.bonus = 0
      if (!dataNew.sale) dataNew.sale = 0
      if (dataNew.bonus < 0) commit('setErrors', { param: 'bonus', value: errorsStr.lessThanZero })
      if (dataNew.sale < 0) commit('setErrors', { param: 'sale', value: errorsStr.lessThanZero })
      if (dataNew.sale > 100) commit('setErrors', { param: 'sale', value: errorsStr.moreThanHundred })
      if (dataNew.useCount < 0) commit('setErrors', { param: 'useCount', value: errorsStr.lessThanZero })
      dataNew.sale = dataNew.sale / 100
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!dataNew.dateEnd) dataNew.dateEnd = null
      if (!isErr) {
        let result = getModel()
        if (!state.id) result = await httpService.post(apiModule[role()].add, dataNew)
        if (!dataNew.groupId) {
          commit('setId', result.data.data.id)
          commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        } else {
          commit('setId', null)
          commit('setOne', getModel())
        }
        dispatch('resetAllErr')
        let promocode = result.data.data
        promocode.sale = promocode.sale * 100
        // if(dataNew.groupId) store.commit('groups/setPromocode', {id: promocode.id, name: promocode.name});
        if (dataNew.groupId) store.commit('groups/setPromocode', promocode)
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async delete ({ state, dispatch }, data) {
    try {
      let id = state.id
      if (data && data.id) id = data.id
      if (id) await httpService.delete(apiModule[role()].delete, { id: id })
      dispatch('toAll')
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
